// extracted by mini-css-extract-plugin
export default {"button":"um-z","reviewSort":"vm-z"};